import { ChangeDetectionStrategy, Component, Input, Pipe, PipeTransform, ViewEncapsulation } from '@angular/core';
import { ExtensionTypes } from 'generated/graphql-types';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { AccountExtensionView } from '../../add-account-extension/models/account-extension-view.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-info',
    styleUrls: ['./extension-info.component.scss'],
    templateUrl: './extension-info.component.html',
    standalone: false
})
export class ExtensionInfoComponent {
   @Input() extension: AccountExtensionView;

   extensionTypes: typeof ExtensionTypes = ExtensionTypes;
}

@Pipe({
    name: 'formatExtension',
    standalone: false
})
export class FormatExtensionPipe implements PipeTransform {
   transform(value: ExtensionOption | string): string {
      if (value === 'Name Directory') {
         return 'Name Directory';
      } else if (value === 'Hangup') {
         return 'Hangup';
      } else if (typeof value === 'object' && value !== null) {
         return `${value.number} - ${value.name}`;
      } else {
         return '';
      }
   }
}
